import React, { useState, useEffect, useContext } from "react";
import { ThemeContext } from "../../../../context/ThemeContext";

// ===================== ICONS =====================
const PushIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

const SmsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

const EmailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 7-10 7L2 7" />
  </svg>
);

const SendIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);

const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const ChevronLeftIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const ChevronRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const TestIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const HistoryIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const SettingsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

// ===================== SUB-COMPONENTS (Theme-Aware) =====================
const Button = ({ children, onClick, variant = "default", size = "default", style, disabled, theme }) => {
  const baseStyle = {
    cursor: disabled ? "not-allowed" : "pointer",
    borderRadius: "10px",
    fontWeight: 600,
    transition: "all 0.2s ease",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    ...(size === "icon" && { width: "36px", height: "36px", padding: 0 }),
    ...(size === "sm" && { padding: "6px 14px", fontSize: "11px", height: "32px" }),
    ...(size === "default" && { padding: "10px 20px", fontSize: "13px" }),
    ...(variant === "primary" && { background: theme.primary, color: "#fff", border: "none", boxShadow: `0 4px 12px ${theme.primary}40` }),
    ...(variant === "success" && { background: theme.success, color: "#fff", border: "none", boxShadow: `0 4px 12px ${theme.success}40` }),
    ...(variant === "danger" && { background: theme.error || theme.danger, color: "#fff", border: "none" }),
    ...(variant === "outline" && { background: "transparent", border: `1px solid ${theme.border}`, color: theme.textSecondary }),
    ...(variant === "ghost" && { background: "transparent", border: "none", color: theme.textSecondary }),
    ...(disabled && { opacity: 0.5 }),
    ...style
  };
  return (
    <button
      onClick={onClick}
      style={baseStyle}
      disabled={disabled}
      onMouseEnter={(e) => {
        if (!disabled && variant === "primary") {
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow = `0 6px 16px ${theme.primary}60`;
        } else if (!disabled && variant === "success") {
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow = `0 6px 16px ${theme.success}60`;
        } else if (!disabled && variant === "outline") {
          e.currentTarget.style.background = theme.surfaceLighter;
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        if (variant === "primary") {
          e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}40`;
        } else if (variant === "success") {
          e.currentTarget.style.boxShadow = `0 4px 12px ${theme.success}40`;
        } else if (variant === "outline") {
          e.currentTarget.style.background = "transparent";
        }
      }}
    >
      {children}
    </button>
  );
};

const ToggleSwitch = ({ checked, onChange, theme }) => {
  return (
    <button
      onClick={onChange}
      style={{
        width: "44px",
        height: "24px",
        borderRadius: "30px",
        border: "none",
        background: checked ? theme.success : theme.border,
        cursor: "pointer",
        transition: "all 0.2s",
        position: "relative",
        flexShrink: 0,
      }}
    >
      <span
        style={{
          position: "absolute",
          top: "2px",
          left: checked ? "22px" : "2px",
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          background: "#fff",
          transition: "all 0.2s",
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        }}
      />
    </button>
  );
};

const StatusBadge = ({ status, theme }) => {
  const configs = {
    sent: { bg: `${theme.success}1a`, color: theme.success, label: "Sent", dot: theme.success },
    pending: { bg: `${theme.warning}1a`, color: theme.warning, label: "Pending", dot: theme.warning },
    failed: { bg: `${theme.error || theme.danger}1a`, color: theme.error || theme.danger, label: "Failed", dot: theme.error || theme.danger },
    scheduled: { bg: `${theme.primary}1a`, color: theme.primary, label: "Scheduled", dot: theme.primary },
    active: { bg: `${theme.success}1a`, color: theme.success, label: "Active", dot: theme.success },
    inactive: { bg: `${theme.textMuted}1a`, color: theme.textMuted, label: "Inactive", dot: theme.textMuted },
  };
  const config = configs[status] || configs.pending;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        padding: "4px 10px",
        borderRadius: "20px",
        fontSize: "11px",
        fontWeight: 600,
        background: config.bg,
        color: config.color,
      }}
    >
      <span style={{ width: "5px", height: "5px", borderRadius: "50%", background: config.dot }} />
      {config.label}
    </span>
  );
};

// ===================== DUMMY DATA =====================
const notificationHistory = [
  { id: 1, type: "push", title: "Weekend Special Offer", message: "Get 20% off on all orders above ₹499", audience: "All Users", sentAt: "2026-05-24 10:30:00", status: "sent", opens: 1245, clicks: 892 },
  { id: 2, type: "sms", title: "Order Confirmation", message: "Your order #543 has been confirmed", audience: "Customers", sentAt: "2026-05-24 09:15:00", status: "sent", recipients: 450 },
  { id: 3, type: "email", title: "Welcome to our platform", message: "Thank you for joining us!", audience: "New Users", sentAt: "2026-05-23 18:00:00", status: "sent", opens: 2340 },
  { id: 4, type: "push", title: "New Restaurant Added", message: "Check out our new partner restaurant", audience: "All Users", sentAt: "2026-05-23 14:20:00", status: "sent", opens: 3421, clicks: 2100 },
  { id: 5, type: "sms", title: "Delivery Update", message: "Your order is out for delivery", audience: "Customers", sentAt: "2026-05-23 11:00:00", status: "failed", recipients: 120 },
  { id: 6, type: "email", title: "Special Discount", message: "Use code SAVE20 for 20% off", audience: "Subscribers", sentAt: "2026-05-22 16:30:00", status: "sent", opens: 5678 },
  { id: 7, type: "push", title: "Flash Sale", message: "Limited time offer! Up to 50% off", audience: "All Users", sentAt: "2026-05-22 12:00:00", status: "scheduled", opens: 0, clicks: 0 },
];

const emailTemplates = [
  { id: 1, name: "Welcome Email", subject: "Welcome to our platform!", body: "Dear {name}, welcome to our platform...", category: "Onboarding", status: "active" },
  { id: 2, name: "Order Confirmation", subject: "Your order has been confirmed", body: "Dear {name}, your order #{orderId} has been confirmed...", category: "Orders", status: "active" },
  { id: 3, name: "Delivery Update", subject: "Your order is out for delivery", body: "Dear {name}, your order is out for delivery...", category: "Orders", status: "active" },
  { id: 4, name: "Promotional Offer", subject: "Special offer just for you!", body: "Dear {name}, get {discount}% off on your next order...", category: "Marketing", status: "inactive" },
];

const smsTemplates = [
  { id: 1, name: "OTP Verification", message: "Your OTP for login is {otp}. Valid for 10 minutes.", category: "Auth", status: "active" },
  { id: 2, name: "Order Confirmation", message: "Order #{orderId} confirmed. Amount: ₹{amount}", category: "Orders", status: "active" },
  { id: 3, name: "Delivery Update", message: "Your order is out for delivery. Track: {trackingLink}", category: "Orders", status: "active" },
];

const audienceSegments = [
  { id: 1, name: "All Users", count: 24500, description: "All registered users" },
  { id: 2, name: "Active Customers", count: 12800, description: "Users who ordered in last 30 days" },
  { id: 3, name: "New Users", count: 3400, description: "Users who joined in last 7 days" },
  { id: 4, name: "Inactive Users", count: 5600, description: "Users inactive for 30+ days" },
  { id: 5, name: "High Value Customers", count: 2100, description: "Users with order value > ₹1000" },
];

// ===================== MAIN COMPONENT (Theme-Aware) =====================
const NotificationSystem = () => {
  const { theme } = useContext(ThemeContext); // ← Theme Context
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [activeTab, setActiveTab] = useState("push");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Push Notification State
  const [pushTitle, setPushTitle] = useState("");
  const [pushMessage, setPushMessage] = useState("");
  const [pushAudience, setPushAudience] = useState("All Users");
  const [pushSchedule, setPushSchedule] = useState("now");
  const [pushScheduleDate, setPushScheduleDate] = useState("");
  const [pushImage, setPushImage] = useState(null);
  const [pushDeepLink, setPushDeepLink] = useState("");

  // SMS Notification State
  const [smsMessage, setSmsMessage] = useState("");
  const [smsAudience, setSmsAudience] = useState("All Users");
  const [smsTemplate, setSmsTemplate] = useState("");

  // Email Notification State
  const [emailSubject, setEmailSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");
  const [emailAudience, setEmailAudience] = useState("All Users");
  const [emailTemplate, setEmailTemplate] = useState("");

  // Settings State
  const [pushSettings, setPushSettings] = useState({
    enabled: true,
    firebaseKey: "AIzaSyB...",
    vapidKey: "BEx...",
    defaultIcon: "/icon.png"
  });
  const [smsSettings, setSmsSettings] = useState({
    enabled: true,
    provider: "Twilio",
    apiKey: "SK...",
    fromNumber: "+1234567890"
  });
  const [emailSettings, setEmailSettings] = useState({
    enabled: true,
    provider: "SendGrid",
    apiKey: "SG...",
    fromEmail: "noreply@restaurant.com",
    fromName: "Restaurant App"
  });

  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3500);
  };

  const handleSendPush = () => {
    if (!pushTitle || !pushMessage) {
      showToast("Please fill title and message", "error");
      return;
    }
    showToast(`Push notification sent to ${pushAudience} successfully!`);
    setPushTitle("");
    setPushMessage("");
  };

  const handleSendSMS = () => {
    if (!smsMessage) {
      showToast("Please enter message", "error");
      return;
    }
    showToast(`SMS sent to ${smsAudience} successfully!`);
    setSmsMessage("");
  };

  const handleSendEmail = () => {
    if (!emailSubject || !emailBody) {
      showToast("Please fill subject and body", "error");
      return;
    }
    showToast(`Email sent to ${emailAudience} successfully!`);
    setEmailSubject("");
    setEmailBody("");
  };

  const handleTestPush = () => {
    showToast("Test push notification sent to your device!", "success");
  };

  const filteredHistory = notificationHistory.filter(n =>
    n.title.toLowerCase().includes(search.toLowerCase()) ||
    n.message.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedHistory = filteredHistory.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);

  const tabs = [
    { id: "push", label: "Push Notification", icon: <PushIcon />, emoji: "📱", color: theme.primary },
    { id: "sms", label: "SMS Notification", icon: <SmsIcon />, emoji: "💬", color: theme.success },
    { id: "email", label: "Email Notification", icon: <EmailIcon />, emoji: "📧", color: theme.info || theme.primary },
    { id: "settings", label: "Settings", icon: <SettingsIcon />, emoji: "⚙️", color: theme.warning },
    { id: "history", label: "History", icon: <HistoryIcon />, emoji: "📜", color: theme.textMuted },
  ];

  const styles = {
    container: {
      minHeight: "100vh",
      background: theme.background,
      fontFamily: "'DM Sans', sans-serif",
      padding: isMobile ? "16px" : "24px",
      transition: "background 0.3s ease",
    },
    contentWrapper: {
      maxWidth: "1400px",
      margin: "0 auto",
    },
    header: {
      marginBottom: "28px",
    },
    title: {
      fontSize: isMobile ? "22px" : "28px",
      fontWeight: 700,
      color: theme.textPrimary,
      margin: 0,
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    subtitle: {
      fontSize: "13px",
      color: theme.textMuted,
      marginTop: "6px",
    },
    tabsContainer: {
      display: "flex",
      gap: "8px",
      marginBottom: "28px",
      flexWrap: "wrap",
      padding: "6px",
      background: theme.surface,
      border: `1px solid ${theme.border}`,
      borderRadius: "14px",
    },
    tabButton: (isActive, color) => ({
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "12px 22px",
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: 600,
      background: isActive ? color : "transparent",
      color: isActive ? "#fff" : theme.textSecondary,
      border: "none",
      cursor: "pointer",
      transition: "all 0.2s ease",
      boxShadow: isActive ? `0 4px 12px ${color}40` : "none",
    }),
    card: {
      background: theme.surface,
      border: `1px solid ${theme.border}`,
      borderRadius: "16px",
      overflow: "hidden",
      marginBottom: "20px",
      boxShadow: `0 4px 12px ${theme.primary}08`,
    },
    cardHeader: {
      padding: "18px 24px",
      borderBottom: `1px solid ${theme.border}`,
      background: theme.surfaceLighter,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "12px",
    },
    cardTitle: {
      fontSize: "16px",
      fontWeight: 700,
      color: theme.textPrimary,
      margin: 0,
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    formGroup: {
      marginBottom: "18px",
    },
    label: {
      display: "block",
      fontSize: "12px",
      fontWeight: 600,
      color: theme.textSecondary,
      marginBottom: "6px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    input: {
      width: "100%",
      padding: "11px 14px",
      background: theme.surfaceLighter,
      border: `1px solid ${theme.border}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: theme.textPrimary,
      outline: "none",
      transition: "border-color 0.2s ease",
      boxSizing: "border-box",
      fontFamily: "inherit",
    },
    textarea: {
      width: "100%",
      padding: "11px 14px",
      background: theme.surfaceLighter,
      border: `1px solid ${theme.border}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: theme.textPrimary,
      outline: "none",
      resize: "vertical",
      fontFamily: "inherit",
      boxSizing: "border-box",
      transition: "border-color 0.2s ease",
    },
    select: {
      width: "100%",
      padding: "11px 14px",
      background: theme.surfaceLighter,
      border: `1px solid ${theme.border}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: theme.textPrimary,
      cursor: "pointer",
      outline: "none",
      boxSizing: "border-box",
    },
    configRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "14px 0",
      borderBottom: `1px solid ${theme.border}`,
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    th: {
      padding: "12px 16px",
      textAlign: "left",
      fontSize: "11px",
      fontWeight: 700,
      color: theme.primary,
      borderBottom: `1px solid ${theme.border}`,
      background: theme.surfaceLighter,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    td: {
      padding: "12px 16px",
      fontSize: "12px",
      color: theme.textSecondary,
      borderBottom: `1px solid ${theme.border}`,
    },
    searchWrapper: {
      position: "relative",
      width: isMobile ? "100%" : "280px",
    },
    searchInput: {
      width: "100%",
      padding: "10px 12px 10px 35px",
      background: theme.surface,
      border: `1px solid ${theme.border}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: theme.textPrimary,
      outline: "none",
      boxSizing: "border-box",
    },
    pagination: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      padding: "16px 20px",
      borderTop: `1px solid ${theme.border}`,
      background: theme.surfaceLighter,
    },
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
      `}</style>

      <div style={styles.contentWrapper}>
        {/* Header */}
        <div style={styles.header}>
          <h1 style={styles.title}>
            🔔 Notification System
          </h1>
          <p style={styles.subtitle}>Send push notifications, SMS, and emails to your users</p>
        </div>

        {/* Tabs */}
        <div style={styles.tabsContainer}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              style={styles.tabButton(activeTab === tab.id, tab.color)}
              onClick={() => setActiveTab(tab.id)}
              onMouseEnter={(e) => {
                if (activeTab !== tab.id) {
                  e.currentTarget.style.background = theme.surfaceLighter;
                  e.currentTarget.style.color = theme.textPrimary;
                }
              }}
              onMouseLeave={(e) => {
                if (activeTab !== tab.id) {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.color = theme.textSecondary;
                }
              }}
            >
              <span>{tab.emoji}</span> {tab.label}
            </button>
          ))}
        </div>

        {/* Push Notification Tab */}
        {activeTab === "push" && (
          <div>
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>📱 Send Push Notification</h3>
              </div>
              <div style={{ padding: "24px" }}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Title *</label>
                  <input
                    style={styles.input}
                    placeholder="Enter notification title"
                    value={pushTitle}
                    onChange={(e) => setPushTitle(e.target.value)}
                    onFocus={(e) => (e.currentTarget.style.borderColor = theme.primary)}
                    onBlur={(e) => (e.currentTarget.style.borderColor = theme.border)}
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Message *</label>
                  <textarea
                    style={styles.textarea}
                    rows="3"
                    placeholder="Enter notification message"
                    value={pushMessage}
                    onChange={(e) => setPushMessage(e.target.value)}
                    onFocus={(e) => (e.currentTarget.style.borderColor = theme.primary)}
                    onBlur={(e) => (e.currentTarget.style.borderColor = theme.border)}
                  />
                </div>
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "16px" }}>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Audience</label>
                    <select style={styles.select} value={pushAudience} onChange={(e) => setPushAudience(e.target.value)}>
                      {audienceSegments.map(seg => <option key={seg.id} value={seg.name}>{seg.name} ({seg.count.toLocaleString()} users)</option>)}
                    </select>
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Schedule</label>
                    <select style={styles.select} value={pushSchedule} onChange={(e) => setPushSchedule(e.target.value)}>
                      <option value="now">Send Now</option>
                      <option value="schedule">Schedule for Later</option>
                    </select>
                  </div>
                </div>
                {pushSchedule === "schedule" && (
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Schedule Date & Time</label>
                    <input
                      type="datetime-local"
                      style={styles.input}
                      value={pushScheduleDate}
                      onChange={(e) => setPushScheduleDate(e.target.value)}
                      onFocus={(e) => (e.currentTarget.style.borderColor = theme.primary)}
                      onBlur={(e) => (e.currentTarget.style.borderColor = theme.border)}
                    />
                  </div>
                )}
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "16px" }}>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Image URL (Optional)</label>
                    <input
                      style={styles.input}
                      placeholder="https://example.com/image.jpg"
                      value={pushImage}
                      onChange={(e) => setPushImage(e.target.value)}
                      onFocus={(e) => (e.currentTarget.style.borderColor = theme.primary)}
                      onBlur={(e) => (e.currentTarget.style.borderColor = theme.border)}
                    />
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Deep Link (Optional)</label>
                    <input
                      style={styles.input}
                      placeholder="app://order/123"
                      value={pushDeepLink}
                      onChange={(e) => setPushDeepLink(e.target.value)}
                      onFocus={(e) => (e.currentTarget.style.borderColor = theme.primary)}
                      onBlur={(e) => (e.currentTarget.style.borderColor = theme.border)}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: "8px" }}>
                  <Button variant="outline" onClick={handleTestPush} theme={theme}><TestIcon /> Test</Button>
                  <Button variant="primary" onClick={handleSendPush} theme={theme}><SendIcon /> Send Push</Button>
                </div>
              </div>
            </div>

            {/* Push Settings */}
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>⚙️ Push Notification Settings</h3>
              </div>
              <div style={{ padding: "20px 24px" }}>
                <div style={styles.configRow}>
                  <span style={{ fontSize: "13px", color: theme.textPrimary, fontWeight: 500 }}>Enable Push Notifications</span>
                  <ToggleSwitch checked={pushSettings.enabled} onChange={() => setPushSettings({ ...pushSettings, enabled: !pushSettings.enabled })} theme={theme} />
                </div>
                <div style={styles.configRow}>
                  <span style={{ fontSize: "13px", color: theme.textPrimary, fontWeight: 500 }}>Firebase Cloud Messaging Key</span>
                  <span style={{ fontSize: "12px", color: theme.textMuted, fontFamily: "monospace", background: theme.surfaceLighter, padding: "4px 10px", borderRadius: "6px" }}>{pushSettings.firebaseKey}</span>
                </div>
                <div style={{ ...styles.configRow, borderBottom: "none" }}>
                  <span style={{ fontSize: "13px", color: theme.textPrimary, fontWeight: 500 }}>VAPID Key</span>
                  <span style={{ fontSize: "12px", color: theme.textMuted, fontFamily: "monospace", background: theme.surfaceLighter, padding: "4px 10px", borderRadius: "6px" }}>{pushSettings.vapidKey}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* SMS Notification Tab */}
        {activeTab === "sms" && (
          <div>
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>💬 Send SMS Notification</h3>
              </div>
              <div style={{ padding: "24px" }}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Use Template</label>
                  <select style={styles.select} value={smsTemplate} onChange={(e) => setSmsTemplate(e.target.value)}>
                    <option value="">Select a template...</option>
                    {smsTemplates.map(t => <option key={t.id} value={t.name}>{t.name}</option>)}
                  </select>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Message *</label>
                  <textarea
                    style={styles.textarea}
                    rows="3"
                    placeholder="Enter SMS message (max 160 characters)"
                    maxLength="160"
                    value={smsMessage}
                    onChange={(e) => setSmsMessage(e.target.value)}
                    onFocus={(e) => (e.currentTarget.style.borderColor = theme.primary)}
                    onBlur={(e) => (e.currentTarget.style.borderColor = theme.border)}
                  />
                  <div style={{ fontSize: "11px", color: smsMessage.length > 140 ? theme.warning : theme.textMuted, marginTop: "6px", textAlign: "right", fontWeight: 500 }}>
                    {smsMessage.length}/160 characters
                  </div>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Audience</label>
                  <select style={styles.select} value={smsAudience} onChange={(e) => setSmsAudience(e.target.value)}>
                    {audienceSegments.map(seg => <option key={seg.id} value={seg.name}>{seg.name} ({seg.count.toLocaleString()} users)</option>)}
                  </select>
                </div>
                <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
                  <Button variant="primary" onClick={handleSendSMS} theme={theme}><SendIcon /> Send SMS</Button>
                </div>
              </div>
            </div>

            {/* SMS Templates */}
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>📋 SMS Templates</h3>
                <Button variant="outline" size="sm" onClick={() => setShowTemplateModal(true)} theme={theme}><PlusIcon /> Add Template</Button>
              </div>
              <div style={{ overflowX: "auto" }}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>Name</th>
                      <th style={styles.th}>Message</th>
                      <th style={styles.th}>Category</th>
                      <th style={styles.th}>Status</th>
                      <th style={styles.th}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {smsTemplates.map(t => (
                      <tr key={t.id} onMouseEnter={(e) => e.currentTarget.style.background = theme.surfaceLighter} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                        <td style={{ ...styles.td, color: theme.textPrimary, fontWeight: 500 }}>{t.name}</td>
                        <td style={styles.td}>{t.message}</td>
                        <td style={styles.td}>{t.category}</td>
                        <td style={styles.td}><StatusBadge status={t.status} theme={theme} /></td>
                        <td style={styles.td}><Button variant="ghost" size="icon" theme={theme}><EditIcon /></Button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* SMS Settings */}
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>⚙️ SMS Settings</h3>
              </div>
              <div style={{ padding: "20px 24px" }}>
                <div style={styles.configRow}>
                  <span style={{ fontSize: "13px", color: theme.textPrimary, fontWeight: 500 }}>Enable SMS</span>
                  <ToggleSwitch checked={smsSettings.enabled} onChange={() => setSmsSettings({ ...smsSettings, enabled: !smsSettings.enabled })} theme={theme} />
                </div>
                <div style={styles.configRow}>
                  <span style={{ fontSize: "13px", color: theme.textPrimary, fontWeight: 500 }}>SMS Provider</span>
                  <span style={{ fontSize: "12px", color: theme.textMuted, background: theme.surfaceLighter, padding: "4px 10px", borderRadius: "6px" }}>{smsSettings.provider}</span>
                </div>
                <div style={{ ...styles.configRow, borderBottom: "none" }}>
                  <span style={{ fontSize: "13px", color: theme.textPrimary, fontWeight: 500 }}>From Number</span>
                  <span style={{ fontSize: "12px", color: theme.textMuted, fontFamily: "monospace", background: theme.surfaceLighter, padding: "4px 10px", borderRadius: "6px" }}>{smsSettings.fromNumber}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Email Notification Tab */}
        {activeTab === "email" && (
          <div>
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>📧 Send Email Notification</h3>
              </div>
              <div style={{ padding: "24px" }}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Use Template</label>
                  <select style={styles.select} value={emailTemplate} onChange={(e) => setEmailTemplate(e.target.value)}>
                    <option value="">Select a template...</option>
                    {emailTemplates.map(t => <option key={t.id} value={t.name}>{t.name}</option>)}
                  </select>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Subject *</label>
                  <input
                    style={styles.input}
                    placeholder="Enter email subject"
                    value={emailSubject}
                    onChange={(e) => setEmailSubject(e.target.value)}
                    onFocus={(e) => (e.currentTarget.style.borderColor = theme.primary)}
                    onBlur={(e) => (e.currentTarget.style.borderColor = theme.border)}
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Body *</label>
                  <textarea
                    style={styles.textarea}
                    rows="5"
                    placeholder="Enter email body (HTML supported)"
                    value={emailBody}
                    onChange={(e) => setEmailBody(e.target.value)}
                    onFocus={(e) => (e.currentTarget.style.borderColor = theme.primary)}
                    onBlur={(e) => (e.currentTarget.style.borderColor = theme.border)}
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Audience</label>
                  <select style={styles.select} value={emailAudience} onChange={(e) => setEmailAudience(e.target.value)}>
                    {audienceSegments.map(seg => <option key={seg.id} value={seg.name}>{seg.name} ({seg.count.toLocaleString()} users)</option>)}
                  </select>
                </div>
                <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
                  <Button variant="primary" onClick={handleSendEmail} theme={theme}><SendIcon /> Send Email</Button>
                </div>
              </div>
            </div>

            {/* Email Templates */}
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>📧 Email Templates</h3>
                <Button variant="outline" size="sm" onClick={() => setShowTemplateModal(true)} theme={theme}><PlusIcon /> Add Template</Button>
              </div>
              <div style={{ overflowX: "auto" }}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>Name</th>
                      <th style={styles.th}>Subject</th>
                      <th style={styles.th}>Category</th>
                      <th style={styles.th}>Status</th>
                      <th style={styles.th}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {emailTemplates.map(t => (
                      <tr key={t.id} onMouseEnter={(e) => e.currentTarget.style.background = theme.surfaceLighter} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                        <td style={{ ...styles.td, color: theme.textPrimary, fontWeight: 500 }}>{t.name}</td>
                        <td style={styles.td}>{t.subject}</td>
                        <td style={styles.td}>{t.category}</td>
                        <td style={styles.td}><StatusBadge status={t.status} theme={theme} /></td>
                        <td style={styles.td}><Button variant="ghost" size="icon" theme={theme}><EditIcon /></Button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Email Settings */}
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <h3 style={styles.cardTitle}>⚙️ Email Settings</h3>
              </div>
              <div style={{ padding: "20px 24px" }}>
                <div style={styles.configRow}>
                  <span style={{ fontSize: "13px", color: theme.textPrimary, fontWeight: 500 }}>Enable Email</span>
                  <ToggleSwitch checked={emailSettings.enabled} onChange={() => setEmailSettings({ ...emailSettings, enabled: !emailSettings.enabled })} theme={theme} />
                </div>
                <div style={styles.configRow}>
                  <span style={{ fontSize: "13px", color: theme.textPrimary, fontWeight: 500 }}>Email Provider</span>
                  <span style={{ fontSize: "12px", color: theme.textMuted, background: theme.surfaceLighter, padding: "4px 10px", borderRadius: "6px" }}>{emailSettings.provider}</span>
                </div>
                <div style={styles.configRow}>
                  <span style={{ fontSize: "13px", color: theme.textPrimary, fontWeight: 500 }}>From Email</span>
                  <span style={{ fontSize: "12px", color: theme.textMuted, fontFamily: "monospace", background: theme.surfaceLighter, padding: "4px 10px", borderRadius: "6px" }}>{emailSettings.fromEmail}</span>
                </div>
                <div style={{ ...styles.configRow, borderBottom: "none" }}>
                  <span style={{ fontSize: "13px", color: theme.textPrimary, fontWeight: 500 }}>From Name</span>
                  <span style={{ fontSize: "12px", color: theme.textMuted, background: theme.surfaceLighter, padding: "4px 10px", borderRadius: "6px" }}>{emailSettings.fromName}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Settings Tab */}
        {activeTab === "settings" && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <h3 style={styles.cardTitle}>⚙️ Global Notification Settings</h3>
            </div>
            <div style={{ padding: "20px 24px" }}>
              <div style={styles.configRow}>
                <div>
                  <div style={{ fontSize: "13px", fontWeight: 600, color: theme.textPrimary }}>Push Notifications</div>
                  <div style={{ fontSize: "11px", color: theme.textMuted, marginTop: "2px" }}>Send real-time alerts to user devices</div>
                </div>
                <ToggleSwitch checked={pushSettings.enabled} onChange={() => setPushSettings({ ...pushSettings, enabled: !pushSettings.enabled })} theme={theme} />
              </div>
              <div style={styles.configRow}>
                <div>
                  <div style={{ fontSize: "13px", fontWeight: 600, color: theme.textPrimary }}>SMS Notifications</div>
                  <div style={{ fontSize: "11px", color: theme.textMuted, marginTop: "2px" }}>Send text messages for important updates</div>
                </div>
                <ToggleSwitch checked={smsSettings.enabled} onChange={() => setSmsSettings({ ...smsSettings, enabled: !smsSettings.enabled })} theme={theme} />
              </div>
              <div style={styles.configRow}>
                <div>
                  <div style={{ fontSize: "13px", fontWeight: 600, color: theme.textPrimary }}>Email Notifications</div>
                  <div style={{ fontSize: "11px", color: theme.textMuted, marginTop: "2px" }}>Send promotional and transactional emails</div>
                </div>
                <ToggleSwitch checked={emailSettings.enabled} onChange={() => setEmailSettings({ ...emailSettings, enabled: !emailSettings.enabled })} theme={theme} />
              </div>
              <div style={{ ...styles.configRow, borderBottom: "none" }}>
                <div>
                  <div style={{ fontSize: "13px", fontWeight: 600, color: theme.textPrimary }}>Daily Notification Limit</div>
                  <div style={{ fontSize: "11px", color: theme.textMuted, marginTop: "2px" }}>Maximum notifications per user per day</div>
                </div>
                <select
                  style={{ ...styles.select, width: "100px" }}
                  onFocus={(e) => (e.currentTarget.style.borderColor = theme.primary)}
                  onBlur={(e) => (e.currentTarget.style.borderColor = theme.border)}
                >
                  <option>5</option><option>10</option><option>20</option><option>50</option>
                </select>
              </div>
            </div>
          </div>
        )}

        {/* History Tab */}
        {activeTab === "history" && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <h3 style={styles.cardTitle}>📜 Notification History</h3>
              <div style={styles.searchWrapper}>
                <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: theme.textMuted, display: "flex" }}>🔍</span>
                <input
                  style={styles.searchInput}
                  placeholder="Search notifications..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onFocus={(e) => (e.currentTarget.style.borderColor = theme.primary)}
                  onBlur={(e) => (e.currentTarget.style.borderColor = theme.border)}
                />
              </div>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Type</th>
                    <th style={styles.th}>Title/Message</th>
                    <th style={styles.th}>Audience</th>
                    <th style={styles.th}>Sent At</th>
                    <th style={styles.th}>Status</th>
                    <th style={styles.th}>Stats</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedHistory.map(n => (
                    <tr key={n.id} onMouseEnter={(e) => e.currentTarget.style.background = theme.surfaceLighter} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                      <td style={{ ...styles.td, color: theme.primary }}>
                        {n.type === "push" && <PushIcon />}
                        {n.type === "sms" && <SmsIcon />}
                        {n.type === "email" && <EmailIcon />}
                      </td>
                      <td style={styles.td}>
                        <div style={{ fontWeight: 600, color: theme.textPrimary, marginBottom: "2px" }}>{n.title}</div>
                        <div style={{ fontSize: "11px", color: theme.textMuted }}>{n.message.substring(0, 50)}...</div>
                      </td>
                      <td style={styles.td}>{n.audience}</td>
                      <td style={{ ...styles.td, fontSize: "11px" }}>{n.sentAt}</td>
                      <td style={styles.td}><StatusBadge status={n.status} theme={theme} /></td>
                      <td style={styles.td}>
                        {n.opens !== undefined && <div style={{ fontSize: "11px" }}>👁️ Opens: <strong style={{ color: theme.textPrimary }}>{n.opens.toLocaleString()}</strong></div>}
                        {n.clicks !== undefined && <div style={{ fontSize: "11px" }}>👆 Clicks: <strong style={{ color: theme.textPrimary }}>{n.clicks.toLocaleString()}</strong></div>}
                        {n.recipients !== undefined && <div style={{ fontSize: "11px" }}>📩 Recipients: <strong style={{ color: theme.textPrimary }}>{n.recipients.toLocaleString()}</strong></div>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {totalPages > 1 && (
              <div style={styles.pagination}>
                <button
                  onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "6px",
                    border: `1px solid ${theme.border}`,
                    background: theme.surface,
                    color: currentPage === 1 ? theme.textMuted : theme.textPrimary,
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: currentPage === 1 ? 0.5 : 1,
                  }}
                >
                  <ChevronLeftIcon />
                </button>
                <span style={{ fontSize: "12px", color: theme.textPrimary, fontWeight: 600 }}>
                  {currentPage} / {totalPages}
                </span>
                <button
                  onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "6px",
                    border: `1px solid ${theme.border}`,
                    background: theme.surface,
                    color: currentPage === totalPages ? theme.textMuted : theme.textPrimary,
                    cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: currentPage === totalPages ? 0.5 : 1,
                  }}
                >
                  <ChevronRightIcon />
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Toast */}
      {toast && (
        <div
          style={{
            position: "fixed",
            bottom: "24px",
            right: "24px",
            zIndex: 1000,
            background: theme.surface,
            border: `1px solid ${toast.type === "error" ? `${theme.error || theme.danger}40` : `${theme.success}40`}`,
            borderRadius: "12px",
            padding: "12px 20px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            boxShadow: `0 8px 32px ${theme.primary}20`,
            animation: "slideUp 0.3s ease",
          }}
        >
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              background: toast.type === "error" ? (theme.error || theme.danger) : theme.success,
            }}
          />
          <span
            style={{
              fontSize: "13px",
              fontWeight: 500,
              color: toast.type === "error" ? (theme.error || theme.danger) : theme.success,
            }}
          >
            {toast.message}
          </span>
          <button
            onClick={() => setToast(null)}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: theme.textMuted,
              display: "flex",
              alignItems: "center",
            }}
          >
            <CloseIcon />
          </button>
        </div>
      )}
    </div>
  );
};

export default NotificationSystem;